import { motion } from 'framer-motion';

const ManifestoVideoSection = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleConsultationClick = () => {
    window.REACT_APP_NAVIGATE('/consultation');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/cb4d46629c236a9cb0414e5b20e0b878.jpg"
          alt="吉野の風景 - 山と桜と伝統的な村落"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center w-full">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-5xl md:text-7xl font-black text-white mb-8 leading-tight">
            吉野、気になる。
            <br />
            でも何から?
          </h1>
          
          <p className="text-2xl md:text-3xl text-white/95 mb-6 font-bold">
            ここは挑戦の現場への入口です
          </p>

          <p className="text-lg md:text-xl text-white/90 mb-16 max-w-3xl mx-auto leading-relaxed">
            決まってなくてOK。挑戦の現場に、あなたの入口を見つけよう
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <a
              href="/about"
              className="bg-white hover:bg-gray-50 text-gray-900 px-8 py-4 rounded-lg text-lg font-bold transition-all shadow-xl hover:shadow-2xl hover:-translate-y-0.5 whitespace-nowrap inline-flex items-center gap-3 cursor-pointer"
              aria-label="我々について"
            >
              <i className="ri-team-line text-xl w-6 h-6 flex items-center justify-center" aria-hidden="true"></i>
              我々について
            </a>
            
            <button
              onClick={handleConsultationClick}
              className="bg-amber-600 hover:bg-amber-700 text-white px-8 py-4 rounded-lg text-lg font-bold transition-all shadow-xl hover:shadow-2xl hover:-translate-y-0.5 whitespace-nowrap inline-flex items-center gap-3 cursor-pointer"
              aria-label="吉野なんでも相談所へ"
            >
              <i className="ri-chat-3-line text-xl w-6 h-6 flex items-center justify-center" aria-hidden="true"></i>
              まず相談する
            </button>
          </div>
        </motion.div>

        {/* Scroll Indicator */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 1 }}
          className="absolute bottom-12 left-1/2 transform -translate-x-1/2"
        >
          <div className="flex flex-col items-center gap-2 text-white/80">
            <span className="text-sm font-medium">スクロール</span>
            <motion.div
              animate={{ y: [0, 10, 0] }}
              transition={{ repeat: Infinity, duration: 1.5 }}
            >
              <i className="ri-arrow-down-line text-2xl" aria-hidden="true"></i>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ManifestoVideoSection;